import {
  Sun,
  Moon,
  Palette,
  Monitor,
  Laptop,
  Sunrise,
  Sunset,
  Code2,
  Code,
  Eye,
  Zap,
  type LucideIcon,
} from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useTheme } from '@/lib/theme/useTheme'
import { THEMES, THEME_META, type Theme } from '@/lib/theme/theme-storage'

// Mapa parcial: temas autorais V's caem no fallback `Palette` para evitar
// cobertura exaustiva conforme novas paletas entram em THEMES.
const THEME_ICONS: Partial<Record<Theme, LucideIcon>> = {
  'vectra-v3': Moon,
  'solarized-light': Sun,
  'tokyo-night-light': Palette,
  'vscode-dark-plus': Monitor,
  'vscode-dark-modern': Laptop,
  'vscode-light-plus': Sunrise,
  'vscode-light-modern': Sunset,
  'vscode-dark-vs': Code2,
  'vscode-light-vs': Code,
  'vscode-dark-hc': Eye,
  'vscode-light-hc': Zap,
}

function iconFor(theme: Theme): LucideIcon {
  return THEME_ICONS[theme] ?? Palette
}

export function ThemeToggle() {
  const [theme, setTheme] = useTheme()
  const meta = THEME_META[theme]
  const Icon = iconFor(theme)

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          aria-label={`Tema atual: ${meta.label}. Clique para mudar.`}
          title={`Tema: ${meta.label}`}
        >
          <Icon className="h-4 w-4" aria-hidden="true" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {THEMES.map((t) => {
          const TIcon = iconFor(t)
          return (
            <DropdownMenuItem
              key={t}
              onClick={() => setTheme(t)}
              className={t === theme ? 'bg-accent text-accent-foreground' : ''}
            >
              <TIcon className="mr-2 h-4 w-4" aria-hidden="true" />
              {THEME_META[t].label}
            </DropdownMenuItem>
          )
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
